import { Controller } from "@hotwired/stimulus"

// "Not now." Hides the element and remembers it in this browser for a while.
//
// localStorage rather than the server because the answer is per-browser and
// worth nothing once it expires — and because the message is not a preference,
// it is a fact that will stop being true on its own.
export default class extends Controller {
    static values = {
        key: String,
        days: { type: Number, default: 1 },
    }

    connect() {
        // Already answered: gone before it can be seen, no exit animation.
        if (this.remembers && this.dismissedUntil > Date.now()) this.element.remove()
    }

    disconnect() {
        clearTimeout(this.timer)
    }

    dismiss(event) {
        event?.preventDefault()

        // No key means a flash: closing it is worth exactly this page load.
        if (this.remembers) {
            const until = Date.now() + this.daysValue * 24 * 60 * 60 * 1000
            try {
                localStorage.setItem(this.storageKey, String(until))
            } catch {
                // Private mode, a full quota — hiding it for this page load is
                // still better than ignoring the click.
            }
        }

        // .remove is the stylesheet's exit animation; it collapses the box so
        // the messages under it slide up rather than jump.
        this.element.classList.add("remove")
        this.element.addEventListener("animationend", () => this.element.remove(), { once: true })
        // animationend never fires when motion is reduced to nothing.
        this.timer = setTimeout(() => this.element.remove(), 700)
    }

    get remembers() {
        return this.hasKeyValue && this.keyValue !== ""
    }

    get storageKey() {
        return `dismissed:${this.keyValue}`
    }

    get dismissedUntil() {
        try {
            return Number(localStorage.getItem(this.storageKey)) || 0
        } catch {
            return 0
        }
    }
}
